import * as CryptoJS from 'crypto-js';

export class EncryptHelper {
  private static readonly Key = CryptoJS.enc.Utf8.parse('a-big-32-char-long-key-123456789');
  private static readonly IV = CryptoJS.enc.Utf8.parse('penguins-16-char');

  public static reversibleEncrypt(plainText: string): string {
    const encrypted = CryptoJS.AES.encrypt(plainText, this.Key, {
      iv: this.IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  public static decrypt(encryptedText: string): string {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, this.Key, {
      iv: this.IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
